import { useQuery } from '@tanstack/react-query';

import { getProperties } from '@arrived/api_v2';
import { Property, PropertyFilters } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { propertiesKey } from './properties.keys';

export function useGetPropertiesQuery(filters?: PropertyFilters, options?: UseQueryOptions<Property[]>) {
  return useQuery(propertiesKey, async () => getProperties(filters), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
